import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { mediaQuery } = baseVariables;

export const StyledInventoryInfo = styled.div`
  .date-section {
    margin: ${toRem(16)} 0;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: ${toRem(8)};
  }

  @media ${mediaQuery.md} {
    .inventory-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .date-section {
      margin: 0;
    }
  }
`;
